/** A list's values, in order, typed for z.enum and pgEnum. */
export function keysOf(list) {
    return Object.keys(list);
}
/** One option in the general shape (label, hint, icon, emoji, learn), or undefined for an unknown value. */
export function optionOf(list, value) {
    return value == null ? undefined : list[value];
}
/** The tooltip for an option: its label, and its hint where it has one. */
export function tooltipOf(list, value) {
    const o = list[value];
    return o ? (o.hint ? `${o.label}: ${o.hint}` : o.label) : value;
}
/** A list's labels by value: for screens that only need the words. */
export function labelsOf(list, short = false) {
    const out = {};
    for (const [k, v] of Object.entries(list))
        out[k] = (short && v.short) || v.label;
    return out;
}
//# sourceMappingURL=core.js.map